'use strict';

/*
 * Main.js
 * @description Require the main application modules.
 */

// Libraries
import 'jquery';
import 'parsleyjs';
import './Plugins/Libraries/jquery.magnific-popup';

// Modules imports
import DomParser from './Modules/DomParser/View';
import ActiveUrlClassSetter from './Modules/ActiveUrlClassSetter/View';
import Accordion from './Modules/Accordion/View';
import Audio from './Modules/Audio/View';
import BxSlider from './Modules/BxSlider/View';
import DomSorter from './Modules/DomSorter/View';
import JqueryTabs from './Modules/JqueryTabs/View';
import Logbuch from './Modules/Logbuch/View';
import Parsley from './Modules/Parsley/View';
import TouchHover from './Modules/TouchHover/View';
import StickyNavigation from './Modules/StickyNavigation/View';
import LocationMap from './Modules/LocationMap/View';

// Plugins imports
import Navgoco from './Plugins/Navgoco/View';
import SolrSuggest from './Plugins/SolrSuggest/View';

let moduleIndex, pluginIndex,
    moduleParser, pluginParser;

// Index of all modules which can be initialized from the DOM.
moduleIndex = {
    ActiveUrlClassSetter: ActiveUrlClassSetter,
    Accordion: Accordion,
    Audio: Audio,
    BxSlider: BxSlider,
    DomSorter: DomSorter,
    JqueryTabs: JqueryTabs,
    Logbuch: Logbuch,
    Parsley: Parsley,
    TouchHover: TouchHover,
    StickyNavigation: StickyNavigation,
    LocationMap: LocationMap
};

pluginIndex = {
    navgoco: Navgoco,
    SolrSuggest: SolrSuggest
};

// Parse the DOM.
moduleParser = new DomParser(moduleIndex, 'module').parse();
pluginParser = new DomParser(pluginIndex, 'plugin').parse();

// Custom functions
import filterExperts from './Plugins/AwiExperts/View';
import './Plugins/MagnificPopup/View';
import './Plugins/AnchorLink/View';
import './Plugins/TotopLink/View';
import './Plugins/SolrSearchResultStyleCustomizer/View';
import './Plugins/FocusFilter/View';

// Initialize global scope functions
window.filterExperts = filterExperts;

$(document).keyup(function(e) {
    if (e.key === "Escape") {
        document.activeElement.blur()
    }
});

import './Redesign/Bundle';
